/* eslint-disable no-unused-vars */
import { TextInput } from '@components';
import { PLANO_TAESA } from '@utils/plans';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export const Beneficiario = ({ beneficiario, index }) => {
  const numeroPlano = useSelector((state) => state.user.data.plano);
  const mostraParentesco = numeroPlano !== PLANO_TAESA;
  const mostraSituacao = beneficiario.situacao === 'Inválido';

  const [exibirDetalhes, setExibirDetalhes] = useState(false);

  const handleVerMaisClick = () => {
    setExibirDetalhes((prev) => !prev);
  };

  return (
    <div className="card mb-32" key={index}>
      <p className="mb-32 text-muted ts-14">Beneficiários para fim de pensão</p>

      <div className="row">
        <div className="col-md-12 col-lg-6">
          <TextInput
            className="mb-2"
            label="Nome completo"
            value={beneficiario.nome}
            disabled
          />
        </div>
        <div className="col-md-12 col-lg-6">
          {mostraParentesco && (
            <TextInput
              className="mb-3"
              label="Parentesco/Vínculo"
              value={beneficiario.parentesco}
              disabled
            />
          )}
        </div>
      </div>

      {exibirDetalhes && (
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <TextInput
              className="mb-3"
              label="Nascimento"
              value={beneficiario.nascimento}
              disabled
            />
          </div>

          <div className="col-md-12 col-lg-6">
            {mostraSituacao && (
              <TextInput
                className="mb-3"
                label="Situação"
                value={beneficiario.situacao}
                disabled
              />
            )}
          </div>
        </div>
      )}
      <div className="text-center pt-2">
        <button
          type="button"
          className="text-orange ts-16 "
          onClick={handleVerMaisClick}
          style={{
            all: 'unset',
            cursor: 'pointer',
          }}
        >
          {exibirDetalhes ? 'Ver menos' : 'Mostrar detalhes'}
        </button>
      </div>
    </div>
  );
};
